import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import appReducer from './reducers';
import './index.css';
import AddPreInstModels from './containers/AddPreInstModels';
import * as serviceWorker from './serviceWorker';

const store = createStore(appReducer);

render(
  <Provider store={store}>
    <AddPreInstModels />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
